/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck
import { isIPad13, isMobile } from 'react-device-detect'
const initialState = {
  isMobile: false,
}
function device(state = initialState) {
  return {
    ...state,
    isMobile: isMobile || isIPad13,
  }
}

export default device
